import './components/public-path';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import Lenis from 'lenis';
import { preloadImages } from './utils';
import header from './components/header';
import animations from './components/animations';
import features from './components/features';
import slider from './components/slider';
import dial from './components/dial';
import search from './components/search';
import recipeFilter from './components/recipe-filter';
import modal, { openModal } from './components/modal';
import product from './components/product';
import tooltip from './components/tooltip';
import collapsable from './components/collapsable';
import about from './components/about';
import print from './components/print';
import errorPage from './components/error-page';
import form from './components/form';
import timer from './components/timer';
import tab from './components/tab';
import mapSearchInputs from './components/product-locator/inputs';
import ambassadorsHub from './components/ambassadors-hub';
import quiz from './components/quiz';
import video from './components/video';

gsap.registerPlugin(ScrollTrigger);

header();
animations();
features();
slider();
dial();
search();
recipeFilter();
modal();
product();
tooltip();
collapsable();
about();
print();
errorPage();
form();
timer();
tab();
mapSearchInputs();
ambassadorsHub();
quiz();
video();

function offsetAnchor() {
    const { hash } = window.location;

    if (hash) {
        const target = document.querySelector(hash);
        if (target) {
            requestAnimationFrame(() => {
                const elementTop = target.getBoundingClientRect().top + window.pageYOffset;
                window.scrollTo({
                    top: elementTop - 160,
                    behavior: 'instant',
                });
            });
        }
    }
}

// Handle hashchange (clicks, internal links)
window.addEventListener('hashchange', offsetAnchor);

// Handle full page load
window.addEventListener('load', offsetAnchor);

// Wait until the Destini widget is initialized
function styleDestiniWidget() {
    const widgetHost = document.querySelector('#destini-locator-4841');
    if (!widgetHost) return;

    const { shadowRoot } = widgetHost;
    if (!shadowRoot) return;

    const style = document.createElement('style');
    style.textContent = `
        .chakra-portal > .chakra-button {
            width: 100%;
            height: 48px;
            font-size: 0.75rem;
            font-weight: 600;
            line-height: 1rem;
            letter-spacing: 0.05em;
        }

        .chakra-portal > .chakra-button:hover {
            background-color: #000000;
        }
    `;

    shadowRoot.appendChild(style);
}

// Run after widget is loaded
setTimeout(styleDestiniWidget, 1500); // Adjust delay based on how/when the widget loads

const container = document.querySelector('.js-pin-container');
if (container) {
    preloadImages('.js-preload').then(() => {
        const lenis = new Lenis({
            lerp: 0.1,
            smooth: true,
        });

        const startLenis = () => {
            lenis.start();
        };

        const stopLenis = () => {
            lenis.stop();
        };

        // lenis.on('scroll', (e) => {
        //     console.log(e);
        // });

        lenis.on('scroll', ScrollTrigger.update);

        gsap.ticker.add((time) => {
            lenis.raf(time * 1000);
        });

        gsap.ticker.lagSmoothing(0);

        const pin = document.querySelector('.js-pin');

        ScrollTrigger.create({
            trigger: pin,
            pin,
            start: 'bottom bottom',
            end: () => `+=${container.offsetHeight - pin.offsetHeight}px`,
        });

        // handle modal
        const modalCampaign = document.querySelector('.js-campaign-modal');
        if (modalCampaign) {
            openModal(
                modalCampaign.innerHTML,
                startLenis,
                stopLenis,
                'campaign',
            );
        }
    });
}
